/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomButton,
  EditProfile,
  FriendsCard,
  Loading,
  PostCard,
  ProfileCard,
  SuggestedFriends,
  TextInput,
  TopBar,
} from "../components";
import { NoProfile } from "../assets";
import { BsFiletypeGif } from "react-icons/bs";
import { BiImages, BiSolidVideo } from "react-icons/bi";
import { useForm } from "react-hook-form";
import {
  apiRequest,
  deletePost,
  fetchPosts,
  getUserInfo,
  handleFileUpload,
  likePost,
} from "../utils";
import { UserLogin } from "../redux/userSlice";
import FriendRequests from "../components/FriendRequests";
import post from "../assets/facebook_post.mp3"

const Home = () => {
  const { user, edit } = useSelector((state) => state.user);
  const { posts } = useSelector((state) => state.posts);
  const [errMsg, setErrMsg] = useState("");
  const [file, setFile] = useState(null);
  const [posting, setPosting] = useState(false);
  const [loading, setLoading] = useState(false);
  const postSound = useRef(new Audio(post));

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handlePostSubmit = async (data) => {
    setPosting(true);
    setErrMsg("");

    try {
      const uri = file && (await handleFileUpload(file));

      const newData = uri ? { ...data, image: uri } : data;

      const res = await apiRequest({
        url: "/posts/create-post",
        data: newData,
        token: user?.token,
        method: "POST",
      });
      
      if (res?.status === "failed") {
        setErrMsg(res);
      } else {
        reset({
          description: "",
        });
        setFile(null);
        setErrMsg("");
        await fetchPost();
      }
      setPosting(false);
      postSound.current.play()


    } catch (error) {
      console.log(error);
      setPosting(false);
    }
  };

  const fetchPost = async () => {
    await fetchPosts(user?.token, dispatch);
    setLoading(false);
  };

  const handleLikePost = async (uri) => {
    await likePost({ uri: uri, token: user?.token });
    await fetchPost();
  };

  const handleDelete = async (id) => {
    await deletePost(id, user.token);
    await fetchPost();
  };

  const getUser = async () => {
    const res = await getUserInfo(user?.token);
    const newData = { token: user?.token, ...res };
    dispatch(UserLogin(newData));
  };

  useEffect(() => {
    setLoading(true);
    getUser();
    fetchPost();
  }, []);

  return (
    <>
      <div className="home w-full px-0 lg:px-10 2xl:px-40 bg-bgColor h-screen overflow-y-auto">
        <div className="w-full flex gap-2 lg:gap-4 pt-5 pb-10 h-full">
          {/* LEFT */}
          <div className="hidden w-1/3 lg:w-1/4 h-full md:flex flex-col gap-6 overflow-y-auto">
            <ProfileCard user={user} />
            <FriendsCard friends={user?.friends} />
          </div>

          {/* Center */}
          <div className="flex-1 h-full px-4 flex flex-col gap-6 overflow-y-auto rounded-lg">
            <form
              onSubmit={handleSubmit(handlePostSubmit)}
              className="bg-primary px-4 rounded-lg"
            >
              <div className="w-full flex items-center gap-2 py-4 border-b border-[#66666645]">
                <img
                  src={user?.profileUrl ?? NoProfile}
                  alt={user?.firstName}
                  className="w-14 h-14 object-cover rounded-full"
                />
                <TextInput
                  styles="w-full rounded-full py-5"
                  placeholder="What's on your mind..."
                  name="description"
                  register={register("description", {
                    required: "Write something about post",
                  })}
                  error={errors.description ? errors.description.message : ""}
                />
              </div>
              {errMsg?.message && (
                <span
                  role="alert"
                  className={`text-sm ${
                    errMsg?.status === "failed"
                      ? "text-[#f6494fe]"
                      : "text-[#2ba150fe]"
                  } mt-0.5`}
                >
                  {errMsg?.message}
                </span>
              )}

              <div className="flex flex-wrap items-center gap-3 py-4">
  {/* Images */}
  <label
    htmlFor="imgUpload"
    className="flex items-center gap-2 text-sm sm:text-base text-ascent-2 hover:text-ascent-1 cursor-pointer"
  >
    <input
      type="file"
      onChange={(e) => setFile(e.target.files[0])}
      className="hidden"
      id="imgUpload"
      accept=".jpg, .png, .jpeg"
    />
    <BiImages size={22} className="sm:size-30" color="#02C103" />
    <span className="hidden xs:inline">Images</span>
  </label>

  {/* Video */}
  <label
    htmlFor="videoUpload"
    className="flex items-center gap-2 text-sm sm:text-base text-ascent-2 hover:text-ascent-1 cursor-pointer"
  >
    <input
      type="file"
      onChange={(e) => setFile(e.target.files[0])}
      className="hidden"
      id="videoUpload"
      accept=".mp4, .wav"
    />
    <BiSolidVideo size={22} className="sm:size-30" color="red" />
    <span className="hidden xs:inline">Video</span>
  </label>

  {/* Gif */}
  <label
    htmlFor="vgifUpload"
    className="flex items-center gap-2 text-sm sm:text-base text-ascent-2 hover:text-ascent-1 cursor-pointer"
  >
    <input
      type="file"
      onChange={(e) => setFile(e.target.files[0])}
      className="hidden"
      id="vgifUpload"
      accept=".gif"
    />
    <BsFiletypeGif size={22} className="sm:size-30" color="#EBAF2C" />
    <span className="hidden xs:inline">Gif</span>
  </label>

  {/* Post Button */}
  <div className="ml-auto">
    {posting ? (
      <Loading />
    ) : (
      <CustomButton
        type="submit"
        title="Post"
        containerStyles="bg-[#1877F2] text-white py-1 px-5 sm:px-6 rounded-full font-semibold text-sm"
      />
    )}
  </div>
</div>

            </form>



            {/* Stories Section */}
<div className="w-full flex gap-3  py-2">
  {/* Add Story */}
  <div className="min-w-[110px] h-44 bg-primary rounded-lg shadow-md flex flex-col items-center justify-center cursor-pointer hover:brightness-95 transition">
    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1877F2] text-white text-xl font-bold">
      +
    </div>
    <p className="text-xs mt-2 text-ascent-2">Add Story</p>
  </div>

  {/* Friend Stories */}
  {user?.friends?.slice(0, 10).map((friend, i) => (
    <div
      key={i}
      className="min-w-[110px] h-44 bg-primary rounded-lg shadow-md relative cursor-pointer hover:brightness-95 transition flex flex-col items-center justify-between"
    >
      {/* Story image (cover) */}
      <img
        src={friend?.profileUrl ?? NoProfile}
        alt={friend?.firstName}
        className="w-full h-32 object-cover rounded-t-lg"
      />

      {/* Name */}
      <p className="text-xs text-ascent-2 text-center w-full px-1 py-2 truncate">
        {friend?.firstName}
      </p>
    </div>
  ))}
</div>


            {loading ? (
              <Loading />
            ) : posts?.length > 0 ? (
              posts?.map((post) => (
                <PostCard
                  key={post?._id}
                  post={post}
                  user={user}
                  deletePost={handleDelete}
                  likePost={handleLikePost}
                />
              ))
            ) : (
              <div className="flex w-full h-full items-center justify-center">
                <p className="text-lg text-ascent-2">No Post Available</p>
              </div>
            )}
          </div>

          {/* RIGHT */}
          <div className="hidden w-1/4 h-full lg:flex flex-col gap-8 overflow-y-auto">
            {/* Friend Request */}
            <FriendRequests />

            {/* Suggested Friends */}
            <SuggestedFriends />
          </div>
        </div>
      </div>

      {edit && <EditProfile />}
    </>
  );
};

export default Home;
